export default __webpack_public_path__ + "static/monitor_b.3b92efdc78e47be20fa37f4957a5d3c7.svg";